import { motion } from 'framer-motion'

export default function WhatsAppFloat() {
  return (
    <motion.a
      className="wa-float"
      href="https://wa.me/918685838583?text=Hello%20Assu%20Buildtech%2C%20I%20am%20interested%20in%20your%20services."
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp Chat"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 3, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.12 }}
    >
      <div className="wa-pulse" />
      <i className="fab fa-whatsapp" style={{ position: 'relative', zIndex: 1 }} />
      <div className="wa-tooltip-label">Chat with us!</div>
    </motion.a>
  )
}
